import React, { useEffect, useRef, useState } from "react";
import MedicardLayout from "./MedicardLayout";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useSurveySrv } from "pages/Survey/useSurveySrv";
import { useSelector } from "react-redux";
import { FilePdfOutlined, FileImageOutlined } from "@ant-design/icons";
import { usePageTitle } from "helpers/usePageTitle";
import whitelabelConfig from "@whitelabel-config";
import { Grid } from "antd";
const downloadCountMap: Record<string, number> = {};

const { useBreakpoint } = Grid;
const MediCard = () => {
  usePageTitle("MEDICARD.PAGE_TITLE", `Medicaid ID Card - ${process.env.REACT_APP_PRODUCT}`);
  const [medicaidId, setMedicaidId] = useState("");
  const targetRef = useRef<HTMLDivElement>(null);
  const { trackMediCardDownload, getMedicaidIDCardData } = useSurveySrv();
  const portalSessionMeta = useSelector(
    (state: any) => state.portal.micrositeSession
  );
  const screens = useBreakpoint();
  useEffect(() => {
    getMedicaidIDCardData()?.then((res: any) => {
      const data = res?.data ?? res ?? {};
      setMedicaidId(data.MedicaidID ?? "");
    });
  }, []);

  const buildPrintEl = (): HTMLDivElement => {
    const printEl = document.createElement("div");
    Object.assign(printEl.style, {
      position: "fixed", left: "-9999px", top: "0",
      width: "794px", minHeight: "1123px",
      background: "#fff", display: "flex",
      flexDirection: "column", alignItems: "center",
      justifyContent: "flex-start",
      padding: "48px 32px", boxSizing: "border-box",
    });
    const cardEl = document.createElement("div");
    cardEl.style.width = whitelabelConfig.uiSettings.mediCardWidth ? whitelabelConfig.uiSettings.mediCardWidth : "560px"; // Card width in pixels
    cardEl.style.height = whitelabelConfig.uiSettings.mediCardHeight ? whitelabelConfig.uiSettings.mediCardHeight : "353px"; // Card height in pixels
    cardEl.innerHTML = (targetRef.current as HTMLElement).innerHTML;
    printEl.appendChild(cardEl);
    document.body.appendChild(printEl);
    return printEl;
  };

  const handleDownload = async (format: "PDF" | "PNG") => {
    const key = `${medicaidId}_${format}`;
    downloadCountMap[key] = (downloadCountMap[key] ?? 0) + 1;

    let status = "Success";
    try {
      const printEl = buildPrintEl();
      const canvas = await html2canvas(printEl, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        width: 794, //A4 width in pixels at 96 DPI
        height: 1123, // A4 height in pixels at 96 DPI
      });
      document.body.removeChild(printEl);

      if (format === "PDF") {
        const pdf = new jsPDF({ unit: "px", format: "a4", orientation: "portrait" });
        const pdfW = pdf.internal.pageSize.getWidth();
        const pdfH = pdf.internal.pageSize.getHeight();
        pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, pdfW, pdfH);
        pdf.save("MediCard.pdf");
      } else {
        const link = document.createElement("a");
        link.download = "MediCard.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
      }
    } catch {
      status = "Failed";
    }

    trackMediCardDownload({
      registrationcode: portalSessionMeta.urlRef,
      memberID: "",
      downloadedDate: new Date().toISOString(),
      downloadedFormat: format,
      status,
    });
  };

  const btnStyle = (color: string): React.CSSProperties => ({
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 18px",
    backgroundColor: color,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
  });

  return (
    <div>
      <div style={{ display: "flex", gap: 12, backgroundColor:"#f3f4f8", marginBottom: 0, justifyContent: "center", position:"fixed", left:"50%",marginLeft:"-50%", width:"100%", zIndex:99, top: screens.md ? "80px" : "70px", padding:"10px 0", }}>
        <button id="medicard-png-btn" onClick={() => handleDownload("PNG")} style={btnStyle("#5e4ad2")}>
          <FileImageOutlined style={{ fontSize: 18, marginRight: 6 }} role="img" alt="File image" /> PNG
        </button>
        <button id="medicard-pdf-btn" onClick={() => handleDownload("PDF")} style={btnStyle("#5e4ad2")}>
          <FilePdfOutlined twoToneColor="#fff" style={{ fontSize: 18, marginRight: 6 }} role="img" alt="File PDF" /> PDF
        </button>
      </div>
      <div
        ref={targetRef}
        className="min-h-screen flex flex-col items-center justify-center bg-gray-900 p-4"
        style={{paddingTop: screens.lg ? "25px" : "35px",}}
      >
        <MedicardLayout />
      </div>
    </div>
  );
};

export default MediCard;